
const Header = (props) => {
    return(
        <>
            <div className="text-center heading shadow-sm mb-2">
                {props.heading}
            </div>
        </>
    )
}

export default Header;